import { normalizeOfficePathname, resolveRumViewName } from '@/features/observability/page/view-name';

let pending: { key: string; startedAt: number } | undefined;

export function getRumDocumentPage(): string {
    const navigation = performance.getEntriesByType('navigation')[0];
    const url = new URL(navigation?.name || window.location.href, window.location.href);
    return resolveRumViewName(url.pathname, url.search);
}

/** 复用 Next 导航通知，只保留最近一次目标，不累积导航历史。 */
export function recordRumNavigation(url: string): void {
    if (typeof window === 'undefined') return;
    const target = new URL(url, window.location.href);
    const pathname = normalizeOfficePathname(target.pathname);
    pending = {
        key: `${pathname}:${resolveRumViewName(pathname, target.search)}`,
        startedAt: performance.now(),
    };
}

export function takeRumNavigationStart(key: string): number | undefined {
    const navigation = pending;
    pending = undefined;
    return navigation?.key === key ? navigation.startedAt : undefined;
}
